import { Container } from '@/components/layout/Container'
import { LinkButton } from '@/components/ui/LinkButton'

export function NotFound() {
  return (
    <Container className="flex min-h-[70vh] flex-col items-center justify-center text-center">
      <h1 className="font-display text-6xl text-carbon">404</h1>
      <p className="mt-4 text-lg text-carbon/60">This page seems to have evaporated.</p>
      <LinkButton to="/" className="mt-8">return home</LinkButton>
    </Container>
  )
}
